import { render, staticRenderFns } from "./fooddetail.vue?vue&type=template&id=61939923&scoped=true"
import script from "./fooddetail.vue?vue&type=script&lang=js"
export * from "./fooddetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61939923",
  null
  
)

export default component.exports